<template>
  <div class="tabs">
    <span v-for="item in tabs"
      :key="item.value"
      :class="{'active': currentItem===item.value}"
      @click="handleClick(item)">
      {{item.label}}
    </span>
  </div>
</template>

<script>
import config from '@/utils/chart/config'
import {mapState} from 'vuex'

export default {
  data() {
    return {
      tabs: [
        {value: 'MIN1', label: '分时'},
        {value: '5-MIN1', label: '5日'},
        {value: 'DAY', label: '日K'}, 
        // {value: 'BS', label: '多空'}, 
        {value: 'WEEK', label: '周K'},
        {value: 'MONTH', label: '月K'},
      ],
      minTabs: [],
      // mins: [
      //   {value: '1-MIN1', label: '1分'},
      //   {value: 'MIN5', label: '5分'},
      //   {value: 'MIN15', label: '15分'},
      //   {value: 'MIN30', label: '30分'},
      //   {value: 'MIN60', label: '60分'},
      // ],
      currentItem: 'MIN1'
    }
  },
  created() {
    if(this.isETF) {
      this.tabs.push({value: 'VALUE', label: '净值'})
    }
  },
  computed: {
    ...mapState(['market']),
    isETF() {
      return !!~this.market.toLowerCase().indexOf('etf')
    }
  },
  methods: {
    handleClick({value, label}) {
      if(value === this.currentItem) return
      this.currentItem = value
      this.currentItem !== 'mins' && this.$emit('tabMutated', value)
    }
  },
}
</script>

<style lang="stylus" scoped>
  .tabs {
    position: relative;
    display: flex;
    font-size: .14rem;
    color: #162641;
    background-color: white
    border-bottom: 0.01rem solid #f5f5f5;
  }
  .tabs span {
    position: relative;
    display: inline-block;
    width: .66rem;
    margin: 0 .12rem;
    text-align: center;
    cursor: pointer;
    height: .37rem;
    line-height: .37rem;
    font-weight: 500
  }
  .active {
    color: #F43737;
    border-bottom: 2px solid #F43737;
  }
</style>